"use client";
import { Box, Container, Flex, Text } from "@chakra-ui/react";
import Tag from "@/_images/png/Tagbig.png";
import { Button } from "@/_components/lib/ui/button";
import Image from "next/image";

interface Props {
  title: string;
  subTitle: string;
  bgColor: string;
  tagTitle: string;
  tagScale: number;
}

export const ComingSoon = ({
  title,
  subTitle,
  bgColor,
  tagTitle,
  tagScale,
}: Props) => {
  return (
    <Container maxW="full">
      <Flex
        minH={"369px"}
        bgColor={bgColor}
        // mt=".5rem"
        p="2rem"
        borderRadius="4xl"
        gap={12}
        align="center"
        pos="relative"
      >
        <Box mt={62.5}>
          <Text textStyle="3xl" color="white" mb={4}>
            {title}
          </Text>
          <Text color="white" maxW="50%" textStyle="sm" fontWeight="light">
            {subTitle}
          </Text>
          <Button
            mt="2rem"
            variant="outline"
            bg="transparent"
            border="1px solid"
            borderColor="white"
          >
            <Text textStyle="md" fontWeight="light" color="white" ml={2}>
              Coming Soon!
            </Text>
          </Button>
        </Box>
        <Box
          pos="absolute"
          top={{ base: "-1.5px", md: 0 }}
          left={{ base: "-0.5px", md: 0 }}
        >
          <Image
            src={Tag}
            alt="Tag"
            // height={100}
            width={250}
            style={{ transform: `scaleX(${tagScale})`, transformOrigin: "0 0" }}
          />
          <Text
            textStyle="3xl"
            color="primary.600"
            mt={6}
            pos="absolute"
            top="-1rem"
            left="1.5rem"
            fontWeight="light"
            fontFamily="heading"
          >
            {tagTitle}
          </Text>
        </Box>
      </Flex>
    </Container>
  );
};
